/** The languages the nav-bar toggles own. An absent `lang` param means this set. */
export const DEFAULT_LANGUAGES = ['en', 'de'] as const;

export type NavLanguage = (typeof DEFAULT_LANGUAGES)[number];

export function isNavLanguage(value: string): value is NavLanguage {
  return (DEFAULT_LANGUAGES as readonly string[]).includes(value);
}

/**
 * Serialises a language set for the `lang` query param. Returns null — i.e. drop
 * the param — only when the set is exactly `DEFAULT_LANGUAGES`, so every other
 * selection survives the round trip through `getLanguageFilter`.
 *
 * The single writer for the nav-bar toggles, the filters pop-up and the default
 * filter guard. Exposed as a plain function so callers that must not take on
 * `CommonDataParamsService`'s dependency chain (the guard) can still use it;
 * `CommonDataParamsService.serializeLanguageParam` delegates here.
 */
export function serializeLanguageParam(langs: string[]): string | null {
  const unique = Array.from(new Set(langs));
  if (unique.length === 0) {
    return null;
  }
  const isDefaultSet =
    unique.length === DEFAULT_LANGUAGES.length &&
    DEFAULT_LANGUAGES.every((lang) => unique.includes(lang));
  return isDefaultSet ? null : unique.join(',');
}
